(() => {
  const commerceContext = [
    '.price',
    '.price-per-item',
    'volume-pricing',
    '.cart-item',
    '.cart__footer',
    '.cart-drawer',
    '.cart-notification',
    '.predictive-search',
    '.quick-order-list',
    '.product-form'
  ].join(',');

  const moneyPattern = /(?:USD|US\$|\$)\s*[-+]?\d[\d,.]*(?:\.\d{1,2})?(?:\s*(?:USD|US\$))?|[-+]?\d[\d,.]*(?:\.\d{1,2})?\s*(?:USD|US\$)/i;

  const revealMoney = (root = document) => {
    const nodes = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches('span.hidden')) {
      nodes.push(root);
    }

    if (root.querySelectorAll) {
      nodes.push(...root.querySelectorAll('span.hidden'));
    }

    nodes.forEach((span) => {
      if (!span.closest(commerceContext)) return;

      const text = span.textContent.replace(/\s+/g, ' ').trim();
      if (!text || !moneyPattern.test(text)) return;

      span.classList.remove('hidden');
      span.classList.add('fg-money-value');
    });
  };

  const start = () => {
    revealMoney(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) revealMoney(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', (event) => revealMoney(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
